import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";

export function maximumXEmploymentReferencesRule(
  rule: components["schemas"]["MaximumEmploymentReferencesRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      employment_references: components["schemas"]["EmploymentReferencesCheckFieldValue"]
    ) => {
      const currentCount = employment_references?.references?.length;
      const ruleValue = rule.value;

      return currentCount < ruleValue;
    },
  };
}
